"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var i18next_1 = require("i18next");
var Option_less_1 = __importDefault(require("./Option.less"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Option = function (_a) {
    var className = _a.className, icon = _a.icon, label = _a.label, children = _a.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, Option_less_1.default['option']) },
        react_1.default.createElement("div", { className: Option_less_1.default['heading'] },
            icon &&
                react_1.default.createElement(react_2.default, { className: Option_less_1.default['icon'], name: icon }),
            react_1.default.createElement("div", { className: Option_less_1.default['label'] }, (0, i18next_1.t)(label))),
        react_1.default.createElement("div", { className: Option_less_1.default['content'] }, children)));
};
exports.default = Option;
